const reg = new RegExp(/^(\s+)$/);

const isSpacedString = (str: string): boolean => {
  return reg.test(str);
};

export default isSpacedString;
